import { useEffect, useRef, useState } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { composerSettingsMenuOpened, aiAssistantsSettingsLinkClicked, replyRecsSettingsLinkClicked } from '../events/ComposerSettingsEvents';
import { trackEvent } from '../../../usage-tracking/clients/usageTracker';
import { ComposerSettingsButton } from './ComposerSettingsButton';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ComposerSettingsMenu = () => {
  const [open, setOpen] = useState(false);
  const settingsButtonRef = useRef(null);
  const replyRecsSettingsLink = `${getFullUrl('app')}/helpdesk-settings/${PortalIdParser.get()}/inboxes/reply-recommendations`;
  const aiAssistantsSettingsLink = `${getFullUrl('app')}/settings/${PortalIdParser.get()}/ai-assistants`;
  const handleOpen = ({
    target: {
      value
    }
  }) => {
    setOpen(value);
  };
  useEffect(() => {
    if (open) {
      trackEvent(composerSettingsMenuOpened);
    }
  }, [open]);
  const SettingsButton = () => /*#__PURE__*/_jsx(ComposerSettingsButton, {
    menuOpen: open,
    onClick: () => setOpen(prev => !prev),
    ref: settingsButtonRef
  });
  SettingsButton.displayName = 'SettingsButton';
  return /*#__PURE__*/_jsx(Dropdown, {
    Button: SettingsButton,
    buttonRef: settingsButtonRef // required for focus to return to button following keyboard escape
    ,
    closeOnOutsideClick: true,
    closeOnMenuClick: false,
    placement: "top",
    open: open,
    onOpenChange: handleOpen,
    arrowSize: "medium",
    children: /*#__PURE__*/_jsxs(List, {
      wrapChildren: true,
      children: [/*#__PURE__*/_jsx(Link, {
        "data-test-id": "reply-recommendations-settings-external-link",
        href: replyRecsSettingsLink,
        external: true,
        use: "unstyled",
        onClick: () => trackEvent(replyRecsSettingsLinkClicked),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.settings.button-labels.reply-recommendations"
        })
      }), /*#__PURE__*/_jsx(Link, {
        "data-test-id": "ai-assistants-settings-external-link",
        href: aiAssistantsSettingsLink,
        external: true,
        use: "unstyled",
        onClick: () => trackEvent(aiAssistantsSettingsLinkClicked),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.settings.button-labels.ai-assistant"
        })
      })]
    })
  });
};
ComposerSettingsMenu.displayName = 'ComposerSettingsMenu';